import { AutogenLayoutOrderMapView } from "./autogen/AutogenLayoutOrderMapView";
import { Map, MapPin, PanelProps, DataSourceAction, DataSourceExecutionEvent, Label, DataDisplayEvent, Panel, TableRowExpansionEvent, Switch, DataSource } from "@mcleod/components";
import { CommonDialogs } from "@mcleod/common";
import { ModelRow, ModelSearchResult } from "@mcleod/core";

export class OrderMapView extends AutogenLayoutOrderMapView {

  private stopsSet = new Set();
  override onLoad() {
    this.addLayoutLoadListener(event =>{
      this.map1.fitPins();
    });
  }

  public setUpMap(response: ModelSearchResult){
    const row = response.modelRows[0].data;

    const positions = row.positions;
    for(let x=positions.length-1; x>-1; x--) {
      this.addPositionPin(positions[x]);
    }
  }

  private addPositionPin(position: any) {
    const pin = new MapPin(position.latitude, position.longitude);

    if(position.image != null)
      pin.image = position.image;
    else
      pin.image = "map-pin-white-dot-large";

    pin.tooltip = position.descr;
    pin.caption = position.sequence;
    if(position.caption_color != null)
      pin.captionColor = position.caption_color;
    else
      pin.captionColor = "Blue";
    pin.layoutName = null;

    const key = position.latitude + position.longitude;
    const descr = position.descr;
    if (descr != null && descr.startsWith("Stop")) {
      if (!this.stopsSet.has(key)) {
        this.map1.addPin(pin);
        this.stopsSet.add(key);
      }
    }
    else{
      pin.clusterable = false;
      this.map1.addPin(pin);
    }
  }
}
